import gql from 'graphql-tag';
import { ACTIVITY_SEARCH_RESULT_FIELDS } from './fragments/common';

const GET_ACTIVITY_SEARCH_RESULTS = gql`
  ${ACTIVITY_SEARCH_RESULT_FIELDS}
  query getActivitySearchResults(
    $seoSegmentId: ID!
    $pageNumber: Int
    $filters: SEOSegmentationFilterInput
    $ipAddress: String!
    $userGeoInfo: String!
    $botInfo: String!
    $userAgent: String!
  ) {
    seoSegmentationSearchResults(
      filters: $filters
      pageNumber: $pageNumber
      testCell: null
      seoSegmentId: $seoSegmentId
      ipAddress: $ipAddress
      botInfo: $botInfo
      userGeoInfo: $userGeoInfo
      userAgent: $userAgent
    ) {
      ... on SEOSegmentationSearchResultsSuccess {
        ...ActivitySearchResultFields

        filters {
          location {
            zipcode
            city
            state
          }
        }
      }
      ... on SEOSegmentationSearchResultsError {
        errors {
          __typename
          message
        }
      }
    }
    seoSegmentationActivityDetails(seoSegmentId: $seoSegmentId) {
      ... on SEOSegmentationActivityDetailsSuccess {
        segmentDetails {
          category
          headline
          location {
            city
            state
          }
          pageType
          searchingFor
          segmentNamePlural
          segmentNamePluralLowerCase
          segmentNameSingular
          segmentNameSingularLowerCase
          seoPageMetadata {
            canonicalURL
            hrefLangLinks {
              countryCode
              languageCode
              url
            }
            indexable
            metaDescriptions
            metaKeywords
            seoPageId
            title
          }
          serviceIdForMember
          subcategory
        }
      }
    }
    seoSegmentationBreadcrumbs(seoSegmentId: $seoSegmentId) {
      ... on SEOSegmentationBreadcrumbsSuccess {
        breadcrumbs {
          content
          url
        }
      }
      ... on SEOSegmentationBreadcrumbsError {
        errors {
          message
        }
      }
    }
    getSEOSegmentationFAQs(seoSegmentId: $seoSegmentId) {
      title
      faqList {
        question
        answer
      }
    }
    getSEOSegmentationLinkSections(seoSegmentId: $seoSegmentId) {
      id
      linkList {
        content
        createDate
        description
        url
        imageDetails {
          imageHeight
          imageSize
          imageUrl
          imageWidth
        }
      }
      title
    }
    seoArticlesList(seoSegmentId: $seoSegmentId) {
      ... on SEOArticlesListSuccess {
        __typename
        seoArticlesList {
          articles {
            createDate
            description
            largeImage {
              imageHeight
              imageSize
              imageUrl
              imageWidth
            }
            smallImage {
              imageHeight
              imageSize
              imageUrl
              imageWidth
            }
            title
            url
          }
        }
      }
      ... on SEOArticlesListError {
        __typename
        errors {
          message
        }
      }
    }
  }
`;

export default GET_ACTIVITY_SEARCH_RESULTS;
